/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase, IWindowMessage } from 'app/shared/lib/essette-site';
import { ICorrespondenceConfig, ITasksConfig } from 'app/core/models/essette-interfaces';
import { TransitionalManager } from 'app/shared/lib/transitional/manager';
import { ISmartTaskBinding, ITaskContainer } from 'app/core/components/tasks/task';
import * as Core from 'app/core/models/essette-api';


/** View-Model for the Correspondence Smart-Task component */
@autoinject()
export class SmartCorrespondence extends ComponentBase {

    ////****************** Fields and Properties ************************************////

    protected task!: Core.Task;
    protected targetId!: string;
    protected tasksConfig: ITasksConfig = {};
    protected correspondenceConfig: ICorrespondenceConfig = {
        transitionalPageId: ''
    };

    private container!: ITaskContainer;
    protected readonly: boolean = false;

    private listener: (event: any) => {};


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(protected readonly transitional: TransitionalManager, ...rest: any[]) {
        super(...rest);
        this.logger.source = this;

        this.listener = this.handleTransitionalMessage.bind(this);
    }

    protected async activate(params: ISmartTaskBinding): Promise<void> {

        if(!params || !params.container || !params.targetId || !params.task || !params.task.id || !params.tasksConfig || !params.tasksConfig.smartTasksConfig || !params.tasksConfig.smartTasksConfig.correspondenceConfig) {
            throw TypeError(`${SmartCorrespondence.name} Component Model not Bound.`);
        }

        const argumentId = params.task.definition?.type?.argument?.id || undefined;

        this.targetId = params.targetId;
        this.tasksConfig = params.tasksConfig;

        // copy correspondence config from smart tasks config
        this.correspondenceConfig = {
            ...params.tasksConfig.smartTasksConfig.correspondenceConfig,
            //taskId: params.task.id,
            //templateId: argumentId
        };

        this.task = params.task;
        this.container = params.container;
        this.readonly = params.readonly;
    }

    protected attached(): void {
        if(!!this.task?.id) {
            this.openLetter(this.task.id);
        }
    }

    protected detached(): void {
        window.removeEventListener('message', this.listener, false);
    }


    ////****************** Events ***************************************************////
    protected addLetterSuccess(): void {
        if(this.container) {
            this.container.completeTask(true);
        }
    }

    ////****************** Functions ************************************************////
    protected openLetter(taskId: string): void {

        const f: HTMLFrameElement = <HTMLFrameElement><unknown>document.getElementById('transitionalFrame');

        if(f && this.correspondenceConfig) {
            this.transitional.openTransitional(f.contentWindow, this.correspondenceConfig.transitionalPageId, [taskId], this.correspondenceConfig.moduleCode);

            window.addEventListener('message', this.listener, false);
        }
    }

    private async handleTransitionalMessage(event: MessageEvent): Promise<void> {
        if(!this.transitional.checkOrigin(event.origin)) {
            this.logger.error(`Transitional message event origin was not allowed: ${event.origin}`);
            return;
        }

        const message: IWindowMessage = event.data ?? null;
        if(!message) {
            this.logger.error(`Transitional message event did not contain data`);
            return;
        }

        if(message.action === 'COMPLETED') {
            this.addLetterSuccess();
        }
    }


    ////****************** Service Calls ********************************************////

}
